import { useContext } from 'react';
import { IntlContext, IntlShape } from 'react-intl';

export const useIsLocalizationInitialized = () => useContext(IntlContext) != null;

/**
 * @internal
 * Hook to access the localization context. Intended for internal use only within Framework.
 * Intentionally cast to IntlShape | null to make absence of context explicit
 * and force proper handling of the uninitialized state.
 */
export const useLocalizationContext = () => useContext(IntlContext) as IntlShape | null;
